var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeUbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131.576,
    height: 131.59,
    viewBox: "0 0 131.576 131.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_746",
    "data-name": "Ret\\xE2ngulo 746",
    width: 131.576,
    height: 131.59,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1232",
    "data-name": "Grupo 1232",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1231",
    "data-name": "Grupo 1231",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2437",
    "data-name": "Caminho 2437",
    d: "M0,51.221V41.207A2.205,2.205,0,0,1,2.31,39.26c1.6-.089,1.635-.158,1.638-1.747.013-6.718,0-13.437.007-20.155,0-3.749.791-4.547,4.5-4.548q16.173-.005,32.347,0c.342,0,.685,0,1.027,0,1.531-.028,1.648-.134,1.659-1.718.018-2.653-.013-5.306.012-7.959C43.521.653,44.184,0,46.637,0Q65.763,0,84.888,0c2.37,0,3.039.661,3.061,3.065.025,2.61,0,5.221.009,7.831.007,1.849.064,1.908,1.98,1.909q14.762.007,29.523,0c1.455,0,2.91-.022,4.364.008,2.638.056,3.642,1.04,3.655,3.7.033,6.761.009,13.523.012,20.284,0,.428.016.856.006,1.283-.018.807.378,1.1,1.162,1.182,2.462.255,2.907.779,2.909,3.234,0,2.61.011,5.221,0,7.831-.009,1.683-.64,2.565-2.252,2.725-1.68.167-1.824.176-1.824,2.312q0,35.882,0,71.763c0,.6,0,1.2-.014,1.8a2.486,2.486,0,0,1-1.937,2.663H5.9a2.486,2.486,0,0,1-1.937-2.66c-.015-.6-.014-1.2-.014-1.8q0-35.479,0-70.958c0-.428.005-.856,0-1.283-.027-1.536-.025-1.559-1.525-1.757A2.505,2.505,0,0,1,0,51.221",
    transform: "translate(0 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2438",
    "data-name": "Caminho 2438",
    d: "M88.676,191.558q27.723,0,55.446-.027c1.174,0,1.57.189,1.567,1.49q-.07,35.813-.01,71.627c0,1.08-.182,1.47-1.372,1.425-2.777-.105-5.562-.086-8.34-.007-1.073.031-1.331-.277-1.329-1.338q.051-29.4.025-58.791c0-2.919-.535-3.462-3.424-3.462q-15.145,0-30.29,0c-2.956,0-3.524.57-3.524,3.524q0,29.331.026,58.662c0,1.1-.221,1.41-1.379,1.408q-31.509-.062-63.018,0c-1.17,0-1.378-.325-1.377-1.417q.049-35.878-.007-71.755c0-1.2.367-1.365,1.432-1.363q27.787.047,55.574.023",
    transform: "translate(-22.955 -138.823)",
    fill: "#0069d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2439",
    "data-name": "Caminho 2439",
    d: "M49.2,85.977c-5.43,0-10.861-.025-16.291.023-.968.009-1.21-.256-1.2-1.215q.066-9.814,0-19.628c0-.888.224-1.15,1.133-1.148q16.419.047,32.838,0c.888,0,1.162.233,1.157,1.141q-.055,9.814,0,19.628c.006.967-.264,1.226-1.221,1.219-5.473-.044-10.946-.021-16.419-.021",
    transform: "translate(-22.977 -46.393)",
    fill: "#0069d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2440",
    "data-name": "Caminho 2440",
    d: "M335.947,85.961c-5.43,0-10.861-.024-16.291.022-1.015.009-1.4-.192-1.388-1.314.056-6.457.045-12.915.008-19.372-.006-.964.187-1.315,1.252-1.311q16.355.064,32.71.008c.861,0,1.174.173,1.168,1.112q-.062,9.878,0,19.757c.006.937-.305,1.121-1.169,1.116-5.43-.036-10.86-.018-16.291-.018",
    transform: "translate(-230.684 -46.378)",
    fill: "#0069d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2441",
    "data-name": "Caminho 2441",
    d: "M175.162,33.78c0-5.477.015-10.954-.017-16.431,0-.8.151-1.084,1.032-1.081q16.493.05,32.987,0c.885,0,1.031.287,1.029,1.084q-.036,16.431.009,32.863c0,1.009-.315,1.178-1.233,1.176q-16.3-.047-32.6.008c-1.088,0-1.23-.38-1.224-1.314.037-5.434.018-10.868.018-16.3",
    transform: "translate(-126.946 -11.79)",
    fill: "#78b4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2442",
    "data-name": "Caminho 2442",
    d: "M300.659,302.891c4.359,0,8.719.024,13.078-.02.895-.009,1.249.128,1.241,1.156-.053,6.582-.042,13.165-.009,19.748,0,.831-.2,1.082-1.057,1.079q-13.206-.047-26.413,0c-.866,0-1.056-.276-1.052-1.1q.047-9.874,0-19.748c0-.9.233-1.15,1.136-1.14,4.359.047,8.719.021,13.078.021",
    transform: "translate(-207.618 -219.523)",
    fill: "#6eacde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2443",
    "data-name": "Caminho 2443",
    d: "M77.243,159.863h59.662c1.677,0,1.677,0,1.678,1.622,0,2.75,0,2.75-2.73,2.75q-59.085,0-118.17,0c-2.042,0-1.794.244-1.8-1.745-.013-2.624,0-2.624,2.6-2.624Z",
    transform: "translate(-11.507 -115.87)",
    fill: "#2775b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2444",
    "data-name": "Caminho 2444",
    d: "M300.745,416.107c-4.407,0-8.813-.019-13.22.017-.8.007-1.094-.158-1.086-1.038q.066-7.766,0-15.532c-.006-.823.262-.983,1.021-.981q13.284.036,26.568,0c.713,0,.938.174.934.913q-.047,7.83,0,15.66c.006.812-.225.985-1,.978-4.406-.039-8.813-.019-13.22-.019",
    transform: "translate(-207.614 -288.89)",
    fill: "#5cd2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2445",
    "data-name": "Caminho 2445",
    d: "M300.818,258.193c-4.443,0-8.887-.024-13.33.021-.857.008-1.064-.249-1.05-1.073.048-2.948.056-5.9,0-8.845-.018-.893.3-1.045,1.1-1.043q13.2.036,26.4,0c.728,0,1.045.1,1.029.952-.057,3.033-.048,6.068,0,9.1.011.753-.242.906-.94.9-4.4-.029-8.8-.015-13.2-.015",
    transform: "translate(-207.61 -179.211)",
    fill: "#5cd2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2446",
    "data-name": "Caminho 2446",
    d: "M93.594,279.491q-9.43,0-18.86,0c-2.365,0-3.009-.659-3.012-3.063q0-4.683,0-9.367c.006-2.121.729-2.956,2.826-2.86,1.35.061,1.584-.383,1.577-1.633-.055-9.409-.031-18.819-.029-28.229,0-2.344.694-3.039,3.075-3.041q14.433-.009,28.867,0c2.423,0,3.073.681,3.074,3.168,0,9.452.018,18.9-.022,28.357,0,1.05.249,1.391,1.337,1.366,2.394-.055,3.065.663,3.072,3.022.009,3.165.017,6.33,0,9.5-.013,2.058-.744,2.78-2.787,2.783q-9.558.012-19.116,0",
    transform: "translate(-51.983 -167.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2447",
    "data-name": "Caminho 2447",
    d: "M217.355,45.545c0,1.326.023,2.652-.007,3.977a2.217,2.217,0,0,1-2.378,2.425,19.882,19.882,0,0,1-2.948-.013c-1.071-.115-1.292.332-1.217,1.28a21.779,21.779,0,0,1,.006,2.821,2.255,2.255,0,0,1-2.478,2.475q-4.1.081-8.209,0a2.253,2.253,0,0,1-2.468-2.484,28.5,28.5,0,0,1,0-3.078c.046-.76-.138-1.071-.968-1.01a28.051,28.051,0,0,1-3.205.009,2.206,2.206,0,0,1-2.367-2.433q-.043-4.169,0-8.339a2.135,2.135,0,0,1,2.3-2.343,29.057,29.057,0,0,1,3.077,0c.863.057,1.247-.167,1.165-1.109a24.537,24.537,0,0,1-.012-2.821c.054-1.852.853-2.669,2.675-2.687q3.912-.038,7.825,0a2.332,2.332,0,0,1,2.663,2.568,23.244,23.244,0,0,1-.009,2.821c-.073.92.155,1.333,1.175,1.233a23,23,0,0,1,2.948-.013,2.2,2.2,0,0,1,2.423,2.485c.025,1.411,0,2.823,0,4.234",
    transform: "translate(-138.509 -23.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2448",
    "data-name": "Caminho 2448",
    d: "M362.6,330.229c.012,2.27-.717,3.353-2.222,3.318-1.469-.034-2.145-1.068-2.145-3.281,0-.384-.016-.769.008-1.151a2.178,2.178,0,0,1,4.354-.036c.028.381,0,.767,0,1.15",
    transform: "translate(-259.647 -237.002)",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2449",
    "data-name": "Caminho 2449",
    d: "M129.714,261.463c0,4.363-.035,8.726.026,13.088.014,1-.3,1.182-1.222,1.178q-11.932-.054-23.864,0c-.894,0-1.235-.126-1.23-1.152q.073-13.088,0-26.176c0-.985.266-1.183,1.2-1.178q11.932.059,23.863,0c1.05-.006,1.251.322,1.24,1.288-.049,4.32-.021,8.64-.021,12.96",
    transform: "translate(-74.964 -179.184)",
    fill: "#5cd2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2450",
    "data-name": "Caminho 2450",
    d: "M104.885,373.357c-5.263,0-10.527-.055-15.788.038-1.364.024-1.687-.4-1.578-1.651a23.6,23.6,0,0,0,0-3.592c-.066-1,.234-1.324,1.273-1.31,4.235.058,8.472.024,12.708.024h19.383c1.63,0,1.63,0,1.632,1.69,0,1.2-.06,2.4.019,3.593.064.965-.261,1.235-1.222,1.227-5.477-.044-10.954-.021-16.43-.021",
    transform: "translate(-63.42 -265.891)",
    fill: "#5cd2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2451",
    "data-name": "Caminho 2451",
    d: "M215.757,48.14c2.211,0,2.211,0,2.211,2.249,0,4.155.221,4.373,4.434,4.373,2.092,0,2.092,0,2.092,2.068,0,2.306,0,2.306-2.37,2.306-3.928,0-4.156.224-4.156,4.1,0,2.424,0,2.424-2.421,2.424a8.829,8.829,0,0,0-1.025.006c-.811.1-1.036-.282-1.007-1.038.042-1.109.045-2.224-.021-3.331a2.076,2.076,0,0,0-2.218-2.149c-1.152-.044-2.307-.037-3.46-.006-.6.017-.891-.17-.816-.8a1.81,1.81,0,0,0,0-.256c-.075-3.327-.075-3.327,3.263-3.333,2.61,0,3.257-.646,3.262-3.237q0-.577,0-1.154c0-2.231,0-2.231,2.229-2.231",
    transform: "translate(-150.024 -34.892)",
    fill: "#dc3e46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2452",
    "data-name": "Caminho 2452",
    d: "M142.653,281.284a2.662,2.662,0,0,1-.9,2.017q-5.2,5.209-10.414,10.409c-1.1,1.09-2.363,1.173-3.285.291-.965-.922-.911-2.241.219-3.38q5.182-5.229,10.4-10.421a2.259,2.259,0,0,1,2.654-.694,2.047,2.047,0,0,1,1.321,1.778",
    transform: "translate(-92.325 -202.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2453",
    "data-name": "Caminho 2453",
    d: "M121.774,274.27a2.177,2.177,0,0,1-2.2-1.181,1.945,1.945,0,0,1,.3-2.375c2.205-2.265,4.427-4.516,6.7-6.711a2.1,2.1,0,0,1,3.092.1,2.206,2.206,0,0,1-.188,3.113c-2.084,2.145-4.213,4.247-6.337,6.353a1.958,1.958,0,0,1-1.368.7",
    transform: "translate(-86.474 -190.896)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeUbs);
export default __webpack_public_path__ + "static/media/Icone_UBS.6a567d0352f239a4f8b61619109dacb7.svg";
export { ForwardRef as ReactComponent };